var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    'alert',
    { [`alert--${_vm.type}`]: _vm.type },
    { [`alert--${_vm.position}`]: _vm.position },
  ]},[(_vm.position === 'fixed')?_c('Container',{staticClass:"alert__container"},[(_vm.isDismissable)?_c('button',{staticClass:"alert__close",attrs:{"type":"button","aria-label":"Close"},on:{"click":_vm.closeAlert}},[_c('CloseSVG',{staticClass:"icon"})],1):_vm._e(),_vm._t("default")],2):[(_vm.isDismissable)?_c('button',{staticClass:"alert__close",attrs:{"type":"button","aria-label":"Close"},on:{"click":_vm.closeAlert}},[_c('CloseSVG',{staticClass:"icon"})],1):_vm._e(),_vm._t("default")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }